import React from 'react';

const BOTTOM_THRESHOLD = 50;

const useScrollRef = (ref: React.RefObject<HTMLElement>) => {
  const [canScroll, setCanScroll] = React.useState(false);

  const updateCanScroll = React.useCallback(() => {
    const { scrollHeight, clientHeight, scrollTop } = ref.current as HTMLDivElement;
    const hasOverflow = scrollHeight > clientHeight;
    const notAtBottom = scrollTop + clientHeight < scrollHeight - BOTTOM_THRESHOLD;
    setCanScroll(hasOverflow && notAtBottom);
  }, [ref]);

  const handleScroll = React.useCallback(() => {
    const target = ref.current;
    target.scrollBy({ top: target.clientHeight, behavior: 'smooth' });
  }, [ref]);

  React.useLayoutEffect(() => {
    const target = ref.current;
    updateCanScroll();
    const resizeObserver = new ResizeObserver(updateCanScroll);
    target.addEventListener('scroll', updateCanScroll);
    resizeObserver.observe(target);
    return () => {
      resizeObserver.disconnect();
      target.removeEventListener('scroll', updateCanScroll);
    };
  }, [updateCanScroll, ref]);

  return { canScroll, handleScroll };
};

export default useScrollRef;
